import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://glet_5505ff315207bffd7af9d41152eee691@observe.gitlab.com:443/errortracking/api/v1/projects/62915309",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});